<div class="floatingactionbutton-wrapper" *ngIf="livePortalzugriffe.length > 0">
  <kendo-floatingactionbutton
  [dialItems]="livePortalzugriffe"
  positionMode="absolute"
  [title]="'freigebendialog.aktuell' | translate"
  (open)="onDialOpen()"
  (close)="onDialClose($event)"
  [offset]="offset"
  [size]="'small'"
  [rounded]="'none'"
  [themeColor]="'base'"
  [text]="livePortalzugriffe.length + ''">
  <ng-template kendoDialItemTemplate let-item>
    <span class="k-fab-item-text">{{ item.name }}</span>
    <kendo-avatar
      class="contact-avatar"
      shape="circle"
      [initials]="item.initials"
      [size]="'medium'"
      [title]="item.initials"
    ></kendo-avatar>
  </ng-template>
</kendo-floatingactionbutton>
</div>